import { track } from "../track";

export const trackMainPageView = (params: { is_first: boolean }) =>
  track({ event: "main_page_view", ...params });
